<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view v-slot="{ Component, route }">
        <transition name="fade" mode="out-in">
          <template v-if="Component">
            <component :is="Component" :key="route.path" />
          </template>
          <div v-else style="padding: 20px; text-align: center;">
            <a-spin size="large" />
          </div>
        </transition>
      </router-view>
    </div>
  </a-config-provider>
</template>

<script>
import { domTitle, setDocumentTitle } from '@/utils/domUtil'
import { i18nRender } from '@/locales'
import { Spin } from 'ant-design-vue'
// import './qiankun'

export default {
  components: {
    'a-spin': Spin
  },
  data() {
    return {}
  },
  computed: {
    locale() {
      // 只是为了切换语言时，更新标题
      const { title } = this.$route.meta
      title && setDocumentTitle(`${i18nRender(title)} - ${domTitle}`)

      return this.$i18n.getLocaleMessage(this.$store.getters.lang).antLocale
    },
  },
  watch: {
    '$route': {
      handler(to, from) {
        console.log('App.vue: 路由变化', {
          from: from?.path,
          to: to.path,
          matched: to.matched?.length || 0,
          matchedRoutes: to.matched?.map(m => ({ 
            path: m.path, 
            name: m.name,
            hasComponent: !!(m.components?.default || m.component),
            componentType: typeof (m.components?.default || m.component)
          })) || [],
          // 检查最后一个匹配的路由（通常是目标路由）
          lastMatched: to.matched && to.matched.length > 0 ? {
            path: to.matched[to.matched.length - 1].path,
            name: to.matched[to.matched.length - 1].name,
            hasComponent: !!(to.matched[to.matched.length - 1].components?.default || to.matched[to.matched.length - 1].component),
            component: to.matched[to.matched.length - 1].components?.default || to.matched[to.matched.length - 1].component
          } : null
        })
      },
      immediate: true
    }
  },
  mounted() {
    console.log('App.vue: mounted', {
      route: this.$route.path,
      matched: this.$route.matched?.length || 0,
      hasComponent: this.$route.matched?.some(m => m.components?.default || m.component) || false,
      // 检查最后一个匹配的路由
      lastMatched: this.$route.matched && this.$route.matched.length > 0 ? {
        path: this.$route.matched[this.$route.matched.length - 1].path,
        name: this.$route.matched[this.$route.matched.length - 1].name,
        hasComponent: !!(this.$route.matched[this.$route.matched.length - 1].components?.default || this.$route.matched[this.$route.matched.length - 1].component),
        component: this.$route.matched[this.$route.matched.length - 1].components?.default || this.$route.matched[this.$route.matched.length - 1].component
      } : null
    })
  }
}
</script>
